if (!global) {
  global = {
    ip: "mc.mythcraft.com",
    discord: {
      id: 892935005880320090,
      url: "https://discord.gg/mc",
    },
  };
}

(function () {
  let url = document.location.pathname.substr(
    0,
    document.location.pathname.length - 1
  );
  if (url === "") url = "/";

  if (document.querySelector('.nav-link[href="' + url + '"]')) {
    document
      .querySelector('.nav-link[href="' + url + '"]')
      .parentElement.classList.add("active");
  }
})();

function modifierValue(modifiers, key, fallback) {
  // If the modifier isn't present, use the default.
  if (modifiers.indexOf(key) === -1) return fallback;

  // If it IS present, grab the value after it: x-show.transition.duration.500ms
  const rawValue = modifiers[modifiers.indexOf(key) + 1];

  if (!rawValue) return fallback;

  if (key === "duration") {
    // Support x-collapse.duration.500ms && duration.500
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) return match[1];
  }

  return rawValue;
}

document.addEventListener("alpine:init", () => {
  // Alpine directive
  Alpine.directive(
    "collapse",
    (el, { expression, modifiers }, { effect, evaluateLater }) => {
      let duration = modifierValue(modifiers, "duration", 250) / 1000;
      let floor = 0;

      el.style.overflow = "hidden";
      if (!el._x_isShown) el.style.height = `${floor}px`;
      if (!el._x_isShown) el.style.removeProperty("display");

      // Override the setStyles function with one that won't
      // revert updates to the height style.
      let setFunction = (el, styles) => {
        let revertFunction = Alpine.setStyles(el, styles);

        return styles.height ? () => {} : revertFunction;
      };

      let transitionStyles = {
        overflow: "hidden",
        transitionProperty: "all",
        transitionDuration: `${duration}s`,
        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)",
      };

      el._x_transition = {
        in(before = () => {}, after = () => {}) {
          let current = el.getBoundingClientRect().height;

          Alpine.setStyles(el, {
            height: "auto",
          });

          let full = el.getBoundingClientRect().height;

          if (current === full) {
            current = floor;
          }

          Alpine.transition(
            el,
            Alpine.setStyles,
            {
              during: transitionStyles,
              start: { height: current + "px" },
              end: { height: full + "px" },
            },
            () => (el._x_isShown = true),
            () => {}
          );
        },

        out(before = () => {}, after = () => {}) {
          let full = el.getBoundingClientRect().height;

          Alpine.transition(
            el,
            setFunction,
            {
              during: transitionStyles,
              start: { height: full + "px" },
              end: { height: floor + "px" },
            },
            () => {},
            () => (el._x_isShown = false)
          );
        },
      };
    }
  );

  // Primary store
  Alpine.store("page", {
    learn: false,
    closeLearn() {
      console.log("shut up");
      this.learn = false;
      localStorage.setItem(
        "__mythLearn",
        JSON.stringify({ active: false, date: new Date().getTime() })
      );
    },
    players: {
      minecraft: 0,
      discord: 0,
    },
    refreshCounts() {
      axios.get("https://api.mcsrvstat.us/2/" + global.ip).then((res) => {
        this.players.minecraft = res.data.players.online;
      });

      axios
        .get(
          "https://discord.com/api/guilds/" + global.discord.id + "/widget.json"
        )
        .then((res) => {
          this.players.discord = res.data.presence_count;
        });
    },
  });

  // Basic menu function
  Alpine.data("menu", () => ({
    open: false,
    attacked: false,
    height: 0,
    init() {
      this.attached = window.scrollY > 0;

      document.addEventListener("scroll", () => {
        this.attached = window.scrollY > 0;
      });
    },
    closeNav() {
      this.open = false;
      this.height = 0;
    },
    toggleNav() {
      if (this.open) return this.closeNav();

      this.open = true;
      this.height = this.$refs.menu.scrollHeight;
    },
  }));

  // Minecraft IP box function
  Alpine.data("minecraft", () => ({
    ip: global.ip,
    copied: false,
    copy() {
      window.navigator.clipboard
        .writeText(this.ip)
        .then(() => {
          this.copied = true;

          setTimeout(() => {
            this.copied = false;
          }, 4000);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  }));

  Alpine.data("discord", () => ({
    players: 0,
    url: global.discord.link,
  }));

  Alpine.data("copyright", () => {
    const year = new Date().getFullYear();
    return {
      year,
      years: year === 2021 ? "2021" : "2021-" + year,
    };
  });

  Alpine.store("page").refreshCounts();

  if (localStorage.getItem("__mythLearn")) {
    Alpine.store("page").learn = JSON.parse(
      localStorage.getItem("__mythLearn")
    ).active;
    let storedDate = new Date(
      JSON.parse(localStorage.getItem("__mythLearn")).date
    );
    storedDate.setDate(storedDate.getDate() + 30);
    let currentTime = new Date().getTime();

    if (storedDate.getTime() > currentTime) {
      JSON.parse(localStorage.getItem("__mythLearn")).active = true;
    }
  } else {
    localStorage.setItem(
      "__mythLearn",
      JSON.stringify({ active: true, time: new Date().getTime() })
    );
  }
});
